.anchor {
  color: var(--color-tertiary-900);
  text-decoration: underline;
  text-underline-offset: 1px;
}
.anchor:active,
.anchor:hover {
  color: var(--color-secondary-900);
  text-decoration: underline;
}
.anchor:focus {
  color: var(--color-secondary-900);
  border-radius: 2px;
  position: relative;
}
.anchor:focus::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  bottom: -2px;
  right: -2px;
  border-radius: 2px;
  box-shadow: 0 0 0 2px rgb(10, 144, 231, 0.62);
}
.bold {
  composes: body2 from global;
  text-decoration: none;
}
.anchor.bold {
  color: var(--color-tertiary-900);
}
.boldSmall {
  composes: body8 from global;
  line-height: 1.25rem;
  text-decoration: none;
}
.anchor.boldSmall {
  color: var(--color-tertiary-900);
}
.bodyText {
  composes: body3 from global;
}
.anchor.bodyText {
  color: var(--color-tertiary-700);
}
.anchor[disabled],
.anchor.disabled {
  color: var(--color-secondary-900);
  cursor: default;
  opacity: 0.5;
  border: none;
  background: none;
  text-decoration: none;
}
.white {
  color: white;
}
.white:active,
.white:hover,
.white:focus {
  color: white;
}
.red {
  color: var(--color-red-700);
}
.red:active,
.red:hover,
.red:focus {
  color: var(--color-red-700);
}
